import { Injectable } from '@angular/core';
import { ApiFeatureSelector, Filter, Pagination } from '@iot-platform/models/common';
import { DeviceVariable } from '@iot-platform/models/i4b';
import { deviceVariablesFeature, adapter, State } from '../reducers/device-variables.reducer';

@Injectable({
  providedIn: 'root'
})
export class DeviceVariablesSelectors extends ApiFeatureSelector<State, DeviceVariable, Pagination, Filter> {
  constructor() {
    super(deviceVariablesFeature.selectDeviceVariablesState, adapter);
  }
}
